"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Editor = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var helpers_1 = require("./helpers");
var Brand = function () { return react_1.default.createElement("div", { className: 'storybook-menus-dashboard-header-brand' },
    react_1.default.createElement(storybook_1.Menus.Dashboard.Logo, null)); };
var Editor = function (_a) {
    var children = _a.children, title = _a.title, user = _a.user, channel = _a.channel;
    return (react_1.default.createElement("div", { className: 'storybook-menus-dashboard-header' },
        react_1.default.createElement("nav", { className: 'storybook-menus-dashboard-nav' },
            react_1.default.createElement(storybook_1.Layouts.Container, null,
                react_1.default.createElement("div", { className: 'storybook-menus-dashboard-header-top' },
                    react_1.default.createElement("div", { className: 'storybook-menus-dashboard-header-top-left' },
                        react_1.default.createElement(storybook_1.Menus.Dashboard.Sidebar, { channel: channel, hamburgerClassName: 'text-secondary', user: user, items: helpers_1.items }),
                        react_1.default.createElement(Brand, null),
                        react_1.default.createElement(storybook_1.Menus.Dashboard.Title, { type: 'editor' }, title)),
                    children && react_1.default.createElement("div", { className: 'storybook-menus-dashboard-header-top-right' }, children))))));
};
exports.Editor = Editor;
exports.Editor.propTypes = {
    /**
     * Current user session
     */
    user: prop_types_1.default.shape({
        id: prop_types_1.default.number,
        permissions: prop_types_1.default.array,
    }),
    /**
     * Current channel session
     */
    channel: prop_types_1.default.shape({
        id: prop_types_1.default.number,
        label: prop_types_1.default.string,
    }),
};
